<section class="section">
    <div class="container">
        <div class="wrapper">
            <div class="col-8">
                <h1>HEMA Schadeverzekeringen zijn over naar InShared</h1>
                <p class="intro-text">
                    Als het goed is, heeft u het al gelezen: de schadeverzekeringen van HEMA zijn per 26 februari 2024
                    over naar InShared.
                </p>
            </div>
            <div class="col-4">
                <div class="hema-transition-puppet">
                    <wuc-picture
                        imageDesktop="/assets/shared/02_home/GIF_01_duimpjes_390x390-no-loop.gif"
                        imageType="image/gif"
                        [imageWidth]="{ desktop: 330 }"
                        [imageHeight]="{ desktop: 330 }"
                        alt="Thumbs up"
                        lazyLoad="false"
                    ></wuc-picture>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section section--content section--desktop section--border section--vertical-spacing">
    <div class="container">
        <div class="wrapper">
            <div class="col-7">
                <ins-chatbot-entry-container></ins-chatbot-entry-container>
            </div>
            <div class="col-5">
                <div class="text-center">
                    <ins-insurances-dropdown></ins-insurances-dropdown>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section section--content">
    <div class="container">
        <wuc-card radius="medium" padding="large">
            <h2>Alles zelf direct regelen</h2>
            <p>
                Net zoals u gewend was bij uw HEMA schadeverzekering, regelt u ook bij InShared heel veel zelf. Omdat we
                alles online doen, is het aanpassen van uw verzekeringen en gegevens een fluitje van een cent. Bij een
                schade heeft u 24/7 inzicht in uw schadedossier. Dag en nacht dus. En het berekenen van een premie is
                natuurlijk heel eenvoudig.
                <wuc-link [url]="'/' + appRoutesEnum.About + '/' + appRoutesEnum.EverythingOnline">Lees meer</wuc-link>
            </p>
        </wuc-card>
        <br />
        <wuc-card radius="medium" padding="large">
            <h2>Meer informatie over de verzekeringen van InShared</h2>
            <p>
                InShared heeft, net als HEMA, veel soorten verzekeringen die u beschermen tegen de financiële gevolgen
                van schade. U kunt de onderstaande verzekeringen bij InShared afsluiten.
            </p>
            <ins-insurance-images-container
                [insurances]="[
                    productIdEnum.Car,
                    productIdEnum.Liability,
                    productIdEnum.Home,
                    productIdEnum.Furniture,
                    productIdEnum.Moped,
                    productIdEnum.Travel,
                    productIdEnum.Pet,
                    productIdEnum.Caravan,
                    productIdEnum.Bicycle,
                    productIdEnum.Legal,
                    productIdEnum.Building,
                    productIdEnum.Accidents,
                    productIdEnum.Scooter,
                    productIdEnum.Motorcycle,
                ]"
            />
            <p>
                Heeft u nu nog vragen over uw HEMA schadeverzekering? Kijk dan op
                <wuc-link rel="nofollow noopener" url="https://verzekerdbijhema.nl">verzekerdbijhema.nl</wuc-link>
            </p>
        </wuc-card>
    </div>
</section>
